<template>
  <div>
    <b-modal ref="modalInstabilidade" @ok="confirmar" title="Atenção" :hide-header-close="true" :no-close-on-esc="true"
      :no-close-on-backdrop="true">
      <p>
        Prezados,
      </p>
      <p>
        Informamos que todos os serviços do Banco Bradesco estão indisponíveis e, por conta disso, nosso gateway de
        pagamento está indisponível. Reforçamos ser uma indisponibilidade geral no Banco Bradesco e estamos aguardando o
        restabelecimento dos serviços por parte do banco.
      </p>
      <p>
        <a href="https://www.techtudo.com.br/noticias/2024/07/bradesco-next-e-outros-bancos-estao-fora-do-ar-hoje-19-entenda-o-motivo-edapps.ghtml"
          target="_blank">
          https://www.techtudo.com.br/noticias/2024/07/bradesco-next-e-outros-bancos-estao-fora-do-ar-hoje-19-entenda-o-motivo-edapps.ghtml
        </a>
      </p>
      <p>
        Qualquer dúvida, estamos à disposição!
      </p>
    </b-modal>
    <b-modal ref="erro" @ok="confirmar" title="Atenção" :hide-header-close="true" :no-close-on-esc="true"
      :no-close-on-backdrop="true">
      <p>{{ this.erro }}</p>
    </b-modal>
    <div class="text-center" v-if="loading" style="
        background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: 10002;
        margin: 0;
        top: 0;
        padding-top: 20%;
      ">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Text Centered"></b-spinner>
      <br /><span style="color: #004e86">Processando Aguarde...</span>
    </div>
    <b-modal ref="cancelar_pedido" title="Atenção">
      <p v-html="mensagem"></p>
      <p>
        <b-form-textarea v-model="motivo_cancelamento" placeholder="Digite o motivo do cancelamento" rows="3"
          max-rows="6"></b-form-textarea>
      </p>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="danger" size="sm" class="float-left" @click="fechar_modal">
            Cancelar Ação
          </b-button>
          <b-button variant="primary" size="sm" class="float-right" @click="efetua_cancelamento_pedido"
            :disabled="carregando">
            Cancelar Pedido
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal id="modal-1" title="Download Certidão" :no-close-on-backdrop="true" :no-close-on-esc="true"
      ref="modalDownloadCertidao" :hide-header-close="habilitaFechar" :hide-footer="true">
      <p class="my-4">
        <template v-if="arquivosCertidao.length > 0">
          <ul class="list-group">
            <li class="list-group-item" v-for="arquivo in arquivosCertidao" :key="arquivo.id">
              {{ arquivo.nm_original }}
              <div style="position: relative;display: flex;float: inline-end;">
                <b-button class="center" v-b-modal.modal-2>
                  <font-awesome-icon icon="download" class="float-right ml-2 mt-1" />
                  Download
                </b-button>
                <b-button class="float-right ml-2" @click="visualizarPDF(arquivo.file)">
                  <font-awesome-icon icon="eye" class="float-right ml-2 mt-1" />
                  Visualizar
                </b-button>
              </div>
            </li>
          </ul>
          <template v-if="qtd > arquivosCertidao.length || arquivosCertidao.length == qtd">
            <br>
            <b-button variant="outline-primary" style="width: 100%;"
              @click="atualizarStatusArq(arquivosCertidao[0].cd_pedido_cartorio, arquivosCertidao[0].idPedido); $bvModal.hide('modal-1');">
              Finalizar </b-button>
          </template>
        </template>
        <template v-else>
          <div class="d-flex justify-content-center mb-3">
            <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
          </div>
        </template>
      </p>
    </b-modal>
    <b-modal ref="modalPagamento" id="modalPagamento" :no-close-on-backdrop="true" :no-close-on-esc="true"
      :hide-header-close="habilitaFechar" size="lg">
      <template v-slot:modal-header="{ close }">
        <h5>Selecione a forma de pagamento</h5>
      </template>
      <template v-slot:default="{ hide }">
        <b-form-select id="input-4" v-model="formaPagamento" :options="formasPagamento"
          @change="alteraFPG"></b-form-select>
        <div v-if="formaPagamento.toString().includes('credit') == true" class="mt-4">
          <b-card bg-variant="light" title="Dados do cartão">
            <parcela-checkout :environment=ENVIRONMENT_EXPRESS :clientKey=CLIENT_KEY_EXPRESS :apiUrl=URL_EXPRESS
              :sellerKey=SELLER_KEY_EXPRESS successReturnUrl="https://success-url.com.br"
              errorReturnUrl="https://error-url.com.br" />
          </b-card>
        </div>
        <p class="mt-3">Caso o pagamento não seja realizado na data de vencimento, o pedido será automaticamente
          cancelado.</p>
        <br>
        <p>A opção de pagamento de certidão/cancelamento, seja por meio de PIX, cartão de crédito ou boleto não altera o
          prazo de entrega/efetivação, pois a transferência ao devido tabelionato, ocorre 1 dia após ao efetivo
          pagamento.</p>
        <br>
        <p><b style="color: red;">*Após realizado o pagamento, os pedidos não poderão mais ser cancelados</b></p>
        <br>
        <p>O processamento dos pagamentos são realizados pela Parcela Express Servicos Digitais.</p>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="lg" variant="danger" class="mr-auto" @click="respConfirm('n')">Cancelar</b-button>
        <b-button size="lg" variant="success" @click="respConfirm('s')"
          v-if="formaPagamento.toString().includes('credit') !== true">Aceitar</b-button>
      </template>
    </b-modal>
    <b-modal ref="ModalPagamentoCartao" title="Pagamento Recusado">
      <p>Pagamento recusado! Verifique os dados do cartão e tente novamente.</p>
    </b-modal>

    <b-modal id="modal-2" title="Download Certidão" :no-close-on-backdrop="true" :no-close-on-esc="true"
      :hide-header-close="habilitaFechar" :hide-footer="true">
      <p class="ml-4">Certidão Eletrônica disponivel em formato p7s (documento com validade jurídica). Para abrir
        documentos
        no formato p7s, assinados eletrônicamente, é necessário ter um programa visualizador de arquivo p7s. Para
        visualização da certidão no formato PDF, clique no botão visualizar.</p>
      <template v-if="arquivosCertidao.length > 0">
        <ul class="list-group">
          <li class="list-group-item" v-for="arquivo in arquivosCertidao" :key="arquivo.id">
            {{ arquivo.nm_original }}
            <div style="position: relative;display: flex;float: inline-end;">
              <b-button class="center" :id="arquivo.id" @click="baixarPDF(arquivo.file, arquivo.id)">
                <a :id="`dwnldLnk${arquivo.id}`" :download="arquivo.nm_original" style="display:none;"
                  v-b-modal.modal-2 />
                <font-awesome-icon icon="download" class="float-right ml-2 mt-1" />
                Download
              </b-button>
            </div>
          </li>
        </ul>
        <template v-if="qtd > arquivosCertidao.length || arquivosCertidao.length == qtd">
          <br>
          <b-button variant="outline-primary" style="width: 100%;"
            @click="atualizarStatusArq(arquivosCertidao[0].cd_pedido_cartorio, arquivosCertidao[0].idPedido); $bvModal.hide('modal-1'); $bvModal.hide('modal-2');">
            Finalizar
          </b-button>
        </template>
      </template>
    </b-modal>

    <b-modal ref="modalInstrumento" size="xl" scrollable title="Certidão anexada" id="modal-dialog">
      <pdfx v-for=" i in numPages" ref="pdfCertidao" :page="i" :src="vpdf" style="width:100%" v-bind:key="i"></pdfx>
    </b-modal>

    <b-modal ref="modalErro" title="Atenção">Nenhum registro encontrado</b-modal>

    <Header :home="false" :arealogada="true" />
    <!-- <Header :home="false" :logged="!logged" :arealogada="true"/> -->
    <b-modal ref="modalBoleto" :size="sizemodalboleto" scrollable title="Boleto" id="modalboleto">
      <div v-if="pdf">
        <div v-if="sizemodalboleto == 'lg'">
          <div class="col-12 text-center">
            <img src="~@/assets/imgs/logo.svg" class="w-50" />
            <br><br><br><br>
            <h4><b>Valor R$: {{ boletoSelecionado.vl_orcamento || Moeda }}</b></h4>
            <br /><br />
          </div>
          <div class="offset-4 col-8 text-center qrcodePix">
            <b-embed type="iframe" aspect="1by1" :src="pdf" allowfullscreen v-if="pdf"></b-embed>
          </div>
          <div class="col-12 text-center">
            <h4><b>Faça a leitura do QR CODE e aguarde.</b></h4>
            <h4><b>Ou</b></h4>
            <b-card>
              <h5><b>LINK DE PAGAMENTO (PIX COPIA E COLA)</b></h5>
              <textarea class="textarea" ref="copiar" v-model="linkPIX" cols="80" rows="4">
          </textarea>
              <b-button variant="primary" @click="copiarLink()">
                <font-awesome-icon icon="copy" /> &nbsp;&nbsp;&nbsp;&nbsp; Copiar link de pagamento
              </b-button>
            </b-card>
            <h4><b><br><br>Consulta de pagamento em {{ secondcd }} segundos.</b></h4>
          </div>
        </div>
        <div v-else>
          <b-embed type="iframe" aspect="1by1" :src="pdf" allowfullscreen v-if="pdf"></b-embed>
        </div>
      </div>
      <p v-else class="mensagemErro bold">{{ mensagemBolErro }}</p>
    </b-modal>
    <b-modal ref="modalLoading" size="xl" title="Carregando" :no-close-on-backdrop="true" :no-close-on-esc="true"
      :hide-footer="true">
      <p class="my-4">
        <template>
          <div class="d-flex justify-content-center mb-3">
            <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
          </div>
        </template>
      </p>
    </b-modal>
    <b-modal ref="statusBoleto" title="Consulta de Status do Boleto">
      <p>Não houve atualização no Status do Boleto.</p>
    </b-modal>
    <Modal
      mensagem="Caso o pagamento não seja realizado na data de vencimento, o pedido será automaticamente cancelado."
      @resposta="respConfirm" />
    <!-- <Header :home="false" :logged="logged" :arealogada="true"/> -->
    <div id="painel" class="container-fluid">
      <b-row>
        <b-col cols="12" md="4" lg="3" v-if="show" style="padding: 0;" class="espaco-menu">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex h-100 w-100 justify-content-center">
          <a style="display:block" :id="'download_boleto'" :download="'download_boleto'" />

          <b-container fluid id="painelcontainerfluid">
            <b-row v-if="cd_produto">
              <b-col cols="10" style="padding: 0;">
                <b-breadcrumb
                  :items="cd_produto.every(e => [2, 4].indexOf(e) > -1) ? certidaoBreadCrumb : cancelamentoBreadCrumb"></b-breadcrumb>
              </b-col>
              <b-col cols="2" style="padding: 0.75rem 1rem;">
                <b-link class="btn-voltar" href="/painel"
                  style="text-decoration:none;font: normal normal bold 16px/24px 'Kanit', sans-serif;color:#597EB5;">
                  Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                </b-link>
              </b-col>
            </b-row>
            <b-alert variant="warning" show v-if="cd_produto">Pesquisas sem filtro irão retornar as 50 ultimas
              solicitações</b-alert>
            <arealogadapesquisa @filtrarBusca="filtrarBusca" :resultado="items" :colunas="colunas"
              :colunasMobile="colunasMobile" :hasFilter="(cd_produto ? true : false)"
              :page="cd_produto.every(e => [2, 4].indexOf(e) > -1) ? 'Certidao' : 'Cancelamento'"
              :title="'Suas Solicitações'" v-if="cd_produto" @chamar-funcao="executarFuncao" />
            <div class="cards-painel d-flex align-items-center justify-content-center" v-if="!cd_produto">
              <a href="/servico/consulta-documento" class="card-painel d-flex align-items-center">
                <img class="w-25 mr-4" src="~@/assets/imgs/icones/carteira-de-identidade.png" />
                <span>Consulta de CPF/CNPJ</span>
              </a>
              <a href="/avise-me" class="card-painel d-flex align-items-center">
                <img class="w-25 mr-4" src="~@/assets/imgs/icones/mensagem.png" />
                <span>Avise-me</span>
              </a>
              <a href="/PedidoProtesto" class="card-painel d-flex align-items-center">
                <img class="w-25 mr-4" src="~@/assets/imgs/icones/bater-papo.png" />
                <span>Envio de título de Protesto</span>
              </a>
              <a href="/servico/autenticidade-protesto" class="card-painel d-flex align-items-center">
                <img class="w-25 mr-4" src="~@/assets/imgs/icones/distintivo.png" />
                <span>Autenticidade de Protesto</span>
              </a>
              <a href="/certidaoNegativa" class="card-painel d-flex align-items-center">
                <img class="w-25 mr-4" src="~@/assets/imgs/icones/certidao.png" />
                <span>Pedido de Certidão</span>
              </a>
              <a href="/anuenciaDigital" class="card-painel d-flex align-items-center">
                <img class="w-25 mr-4" src="~@/assets/imgs/icones/acordo_1.png" />
                <span></span>
                <span>Autorização de Cancelamento (Carta de anuência eletrônica)</span>
              </a>

            </div>


            <a id="downloadIPcAncelamento" download="downloadIPcAncelamento" style="display:none;" />
            <a id="Recibo" download="Recibo" style="display: none" />
            <a id="Recibo_complemento" download="Recibo_complemento" style="display: none" />
            <a id="Certidao_Cancelamento" download="Certidao_Cancelamento" style="display: none" />
            <template v-if="items.length > 0 && !ip_cancelamento">
            </template>
          </b-container>
        </b-col>
      </b-row>
    </div>
    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none" />
  </div>
</template>

<script>
import axios from "axios"
import Header from '../components/Header'
import API from '../services/api'
import Menu from '../template/Menu'
import Modal from '../components/modal/Confmodal'
import pdfx from "vue-pdf";
import '@parcelaexpress/checkout-component-js';
import arealogada from "@/components/arealogada/index.vue";
import arealogadapesquisa from "@/components/arealogada/pesquisa/index.vue";
import footersite from "@/components/footersite";
import footersitemobile from "@/components/footersite/index_mobile";

export default {
  components: {
    Header,
    Menu,
    Modal,
    pdfx,
    arealogada,
    arealogadapesquisa,
    footersite,
    footersitemobile
  },
  data() {
    return {
      cancelamentoBreadCrumb: [
        { text: 'Painel', href: "/painel" },
        { text: 'Cancelamento', disabled: true },
        { text: 'Todos os Pedidos', active: true }
      ],
      certidaoBreadCrumb: [
        { text: 'Painel', href: "/painel" },
        { text: 'Certidão', disabled: true },
        { text: 'Todos os Pedidos', active: true }
      ],
      primeiraBusca: true,
      mensagem: null,
      cd_pedido_atual: null,
      motivo_cancelamento: null,
      carregando: false,
      pdf: null,
      vpdf: "",
      perPage: 0,
      currentPage: 1,
      habilitaFechar: true,
      sizemodalboleto: 'xl',
      numPages: 0,
      secondcd: 30,
      percent_value: '',
      linkPIX: '',
      CLIENT_KEY_EXPRESS: process.env.VUE_APP_CLIENT_KEY_EXPRESS,
      SELLER_KEY_EXPRESS: process.env.VUE_APP_SELLER_KEY_EXPRESS,
      URL_EXPRESS: process.env.VUE_APP_URL_EXPRESS,
      ENVIRONMENT_EXPRESS: process.env.VUE_APP_ENVIRONMENT_EXPRESS,
      cd_produto: [],
      ip_cancelamento: false,
      colunas: [
        { label: 'Nº Pedido', key: 'cd_pedido', sortable: false, size: '0.5fr' },
        { label: 'Solicitante', key: 'nm_solicitante', sortable: false, size: '1.5fr' },
        { label: 'Documento', key: 'documento_pedido', sortable: true, size: '1fr' },
        { label: 'Pesquisado', key: 'nm_pesquisado', sortable: true, size: '1.5fr' },
        { label: 'Tipo Pedido', key: 'nm_produto', sortable: true, size: '1fr' },
        { label: 'Data Pedido', key: 'data_pedido', sortable: true, size: '1fr', isDate: true },
        { label: 'Status', key: 'status_pedido', sortable: true, size: '1fr' },
        { label: 'Exibir', key: 'details', sortable: false, size: '0.5fr' },
        {
          key: "actions", label: "Ação", sortable: false, size: "0.5fr", acoes: [
            { icone: 'dollar-sign', tamanho: '1x', titulo: 'Gerar Pagamento', cor: 'text-primary', condicao: 'libGerarBoleto', funcao: 'gerarBoleto' /*'gerarBoleto_instabilidade'*/},
            { icone: 'plus-square', tamanho: '1x', titulo: 'Mais Opções', cor: 'text-primary', condicao: 'maisAcoes', funcao: 'abrirMaisOpcoes' },
            { icone: 'money-bill-wave', tamanho: '1x', titulo: 'Recibo', cor: 'text-success', condicao: 'libDownloadRecibo', funcao: 'downloadRecibo' },
            { icone: 'download', tamanho: '1x', titulo: 'Download Certidão', cor: 'text-info', condicao: 'libDownloadCertidao', funcao: 'trazerArquivos' },
            { icone: 'download', tamanho: '1x', titulo: 'Download Certidão Cancelamento', cor: 'text-info', condicao: 'ic_certidao_cancelamento', funcao: 'downloadCertidaoCancelamento' },
            { icone: 'dollar-sign', tamanho: '1x', titulo: 'Exibir Pagamento', cor: 'text-success', condicao: 'ic_exibe_boleto', funcao: 'selecionarBoleto' /*'gerarBoleto_instabilidade'*/},
            { icone: 'trash', tamanho: '1x', titulo: 'Cancelar Pedido', cor: 'text-danger', condicao: 'ic_cancela_pedido', funcao: 'cancelar_pedido' }
          ]
        }
      ],
      colunasMobile: [
        { label: 'Nº Pedido', key: 'cd_pedido', sortable: false, size: '0.75fr' },
        { label: 'Pesquisado', key: 'nm_pesquisado', sortable: true, size: '1.5fr' },
        { key: "actions", label: "Exibir", sortable: false, size: "0.5fr" }
      ],
      fields: [
        { key: 'select_head', label: '' },
        { key: 'cd_pedido', label: 'Nº Pedido', sortable: false },
        { key: 'nm_solicitante', label: 'Solicitante', sortable: false },
        { key: 'documento_pedido', label: 'Documento', sortable: true },
        { key: 'nm_pesquisado', label: 'Pesquisado', sortable: true },
        { key: 'nm_produto', label: 'Tipo Pedido', sortable: true },
        { Key: 'Doc_Pesquisado', label: 'Doc_Pesquisado', sortable: true },
        { key: 'data_pedido', label: 'Data Pedido', sortable: true },
        { key: 'status_pedido', label: 'Status', sortable: true },
        { key: 'Exibir', label: 'Exibir', sortable: false },
        { key: "actions", label: "Ação" }
      ],
      qtd: 0,
      customerData: {
        amount_cents: 2,
      },
      arquivosCertidao: [],
      dadosBoleto: [],
      mensagemBolErro: "",
      boletoSelecionado: {},
      items: [],
      nameLoad: false,
      showLoad: false,
      showOption: "",
      loading: false,
      cartorios: [],
      certidao: true,
      show: true,
      toggle: false,
      logged: false,
      certidoes: [],
      cd_certidao: null,
      erro: false,
      solicitante: {
        nome: '',
        documento: '',
        email: '',
        celular: '',
        endereco: '',
        complemento: '',
        bairro: '',
        municipio: '',
        uf: ''
      },
      service: {
        cep: '',
        valor: '',
        entrega: '',
        codigo: ''
      },
      form: {
        DataInicial: '',
        DataFinal: '',
        nomePesquisado: '',
        documentoPesquisado: '',
        status: '',
        tpPedido: '',
        DataSolicitacao: '',
        chave_ip_cancelamento: '',
        nrPedido: '',
        vl_titulo: '',
        vl_saldo: '',
      },
      intervaloDataCheck: true,
      statusPedido: [{ text: 'Selecione', value: null }],
      tipoPedido: [{ text: 'Selecione', value: null }],
      statusSelected: null,
      tipoPedidoSelected: null,
      formasPagamento: [
        { text: 'Selecione uma opção de pagamento', value: 0 },
        { text: 'BOLETO - Parcela Express ( Tarifa Bancária - R$ 0,87 )', value: 2 }, //comentado até virada da tabela de custas
        { text: 'PIX - Parcela Express ( Gratuito )', value: 3 },
        // { text: 'Cartão de Crédito - Parcela Express ( Tarifa Bancária - 2,89% )', value: 4 }
      ],
      formasPagamentoExpress: [],
      formaPagamento: 0,
      mesesValidade: [{ text: 'Mês', value: 0 }, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      anosValidade: [{ text: 'Ano', value: 0 }],
      mesValidade: 0,
      anoValidade: 0
    }
  },
  computed: {
    rows() {
      return this.items.length
    },
  },
  filters: {
    documento: function (value) {
      if (value == null) {
        return '';
      } else {
        let v = value;
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g, "");
        if (v.length < 14) { //CPF
          //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um hífen entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else { //CNPJ
          //Coloca ponto entre o segundo e o terceiro dígitos
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          //Coloca ponto entre o quinto e o sexto dígitos
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          //Coloca uma barra entre o oitavo e o nono dígitos
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          //Coloca um hífen depois do bloco de quatro dígitos
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
        }
        return v;
      }
    },
    dataHora: function (value) {
      if (value !== "" && value !== undefined && value !== null) {
        let date = new Date(value);
        return date.toLocaleDateString("pt-BR", {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        });
      }
      return "";
    },
    Celular: function (value) {
      var d = value
      d = d.replace(/\D/g, "")
      d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
      d = d.replace(/(\d{5})(\d)/, "$1-$2")
      return d
    },
    Telefone: function (value) {
      var d = value
      d = d.replace(/\D/g, "")
      d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
      d = d.replace(/(\d{4})(\d)/, "$1-$2")
      return d
    },
    CEP: function (value) {
      var d = value
      d = d.replace(/\D/g, "")
      d = d.replace(/^(\d{5})(\d)/, "$1-$2")
      return d
    },
    Moeda: function (v) {
      /*var p = v.indexOf(".");
      v = v.slice(0, (p+3))
      v = v.replace(/\D/g,'');
      v = (v/100).toFixed(2) + '';
      */
      v = v.toString().replace(".", ",");
      v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
      v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
      return 'R$ ' + v;
    }
  },
  created: function () {
    this.primeiraBusca = true;
    this.cd_produto = this.$route.meta.cd_produto
    if (this.cd_produto == undefined) this.cd_produto = '';
    const dataAtual = new Date();
    const anoAtual = dataAtual.getFullYear();
    this.anosValidade.push({ text: anoAtual, value: anoAtual })
    for (let i = 1; i < 7; i = i + 1) {
      this.anosValidade.push({ text: anoAtual + i, value: anoAtual + i })
    }
    this.loading = true;
    var self = this;
    const token = localStorage.getItem('jwtToken')
    const nm_chave = localStorage.getItem('nm_chave')
    const vl_protestado = localStorage.getItem('vl_protestado')
    const cpfCnpj = localStorage.getItem('cpfCnpj')
    this.ip_cancelamento = localStorage.getItem('instrumento_protesto_cancelamento')
    if (!this.ip_cancelamento) {

      if ((nm_chave != 'null' && nm_chave != "" && nm_chave != null && nm_chave != undefined) &&
        (cpfCnpj != 'null' && cpfCnpj != "" && cpfCnpj != null && cpfCnpj != undefined)) {
        this.cadastrarPedidoCancelamentoAnuencia(nm_chave, cpfCnpj, vl_protestado)
      }

      API.get(`certidao/listaStatusPedido?token=${token}`).then((res) => {
        self.statusPedido = res.data
      })


      API.get(`consulta/tipoPedido?token=${token}`).then((res) => {
        self.tipoPedido = res.data
      })
      API.post(`teste_requisicao`).then((res) => {
      })

      this.get_certidoes();
      var interval = setInterval(function () {
        if (self.$refs["certidoes"] != undefined && self.$refs["certidoes"].items[localStorage.getItem('indexPedido')] != undefined)
          self.$refs["certidoes"].items[localStorage.getItem('indexPedido')]._showDetails = true;
      }, 500)

      setTimeout(function () {
        localStorage.setItem('indexPedido', '');
        clearInterval(interval);
      }, 5000)

      this.logged = true
      // this.verificarConta();
    }

    // let dadosUsuario =  API.get(`usuario/logado?token=${token}`).then( (res) =>  {
    //   setTimeout(() => {
    //     API.get(`usuario/dadosbancarios?token=${token}`).then((dadosBancarios) => {

    //       //  if (!res.data[0].nm_nr_cep || !res.data[0].nm_nr_telefone) { -- Nessa condição, nm_nr_cep E nm_nr_telefone são obrigatorios
    //       if (!res.data[0].nm_nr_cep && !res.data[0].nm_nr_telefone) { // Nessa condição, somente um dos valores é obrigatorio
    //         this.loading = false;
    //         this.erro = 'Cadastro do usuário incompleto. Para realizar esse procedimento é preciso fornecer mais informações.'
    //         this.errorPush = {name: 'cadastroUser'}
    //         // this.errorPush = {name: 'cadastroUser', params: {dadosLiq: 'liquidacao', dadosBancarios:0}}
    //         this.$refs['erro'].show();
    //       }
    //     })
    //   })
    // })

    if (this.ip_cancelamento) this.loading = false;
  },
  methods: {
    gerarBoleto_instabilidade() {
      this.$refs['modalInstabilidade'].show();
    },
    executarFuncao: function (funcao, linha) {
      if (this[funcao]) {
        this[funcao](linha)
      }
    },
    switchIntervaloData() {
      this.form.DataInicial = "";
      this.form.DataSolicitacao = "";
      this.form.DataFinal = "";
    },
    async cadastrarPedidoCancelamentoAnuencia(nm_chave, cpfCnpj, vl_protestado) {
      const token = localStorage.getItem('jwtToken')
      //const res = 
      await API.post(`/anuencia/pedido/cancelamento`, { nm_chave: nm_chave, cpfCnpj: cpfCnpj, vl_protestado: vl_protestado, token: token })
      //zerar a nm_chave
      localStorage.setItem('nm_chave', '');
      localStorage.setItem('vl_protestado', '');
    },
    async atualizarStatusArq(cd_pedido_cartorio, cd_pedido) {
      var self = this
      self.qtd = 0
      const token = localStorage.getItem('jwtToken')
      await API.put(`certidao/arquivos/update/status/${cd_pedido_cartorio}/${cd_pedido}?token=${token}`)
      this.get_certidoes();

    },
    visualizarPDF(pdf) {
      let loadingTask = pdfx.createLoadingTask(pdf);
      loadingTask.then(pdf => {
        this.numPages = pdf.numPages
      })
      this.vpdf = loadingTask
      //console.log(pdfx.createLoadingTask(pdf))
      this.$refs["modalInstrumento"].show();

    },
    baixarPDF: function (pdf, id) {
      // var eleman = document.getElementById(id);
      // eleman.setAttribute("disabled", true);
      // var dlnk = document.getElementById('dwnldLnk' + id);
      // dlnk.href = pdf;
      // dlnk.click();

      const base64String = this.removeBase64Prefix(pdf)
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'download_certidao.pdf'; // the name of the file to download
      link.click();
      this.qtd = this.qtd + 1;
    },
    removeBase64Prefix(base64String) {
      const pdfPrefix = "data:application/pdf;base64,";
      const p7sPrefix = "data:application/pkcs7-signature;base64,";

      if (base64String.startsWith(pdfPrefix)) {
        return base64String.substring(pdfPrefix.length);
      } else if (base64String.startsWith(p7sPrefix)) {
        return base64String.substring(p7sPrefix.length);
      } else {
        throw new Error("Unknown base64 prefix");
      }
    },
    baixarIPCancelamento: function (pdf) {
      var eleman = document.getElementById('downloadIPcAncelamento');
      eleman.setAttribute("disabled", true);
      var dlnk = document.getElementById('downloadIPcAncelamento');
      dlnk.href = "data:application/pdf;base64," + pdf;
      dlnk.click();
    },
    async trazerArquivos(row) {
      let cd_pedido_cartorio = row.cd_certidao
      let idPedido = row.cd_pedido
      // console.log(row)
      var self = this
      self.arquivosCertidao = []
      self.qtd = 0
      const token = localStorage.getItem('jwtToken')
      const res = await API.post('certidao/arquivos/download', { id: cd_pedido_cartorio, token: token })
      var i = 0;
      this.$refs["modalDownloadCertidao"].show();
      /**
       * quando a variavel do back-end habilitaFechar vier como true
       * a variavel habilitaFechar do front-end deve ser false
       * pois o atributo no front é :
       * hide-header-close: true -- esconde
       * hide-header-close: false -- mostra
       *
       */
      if (res.data[0].habilitaFechar == true) {
        this.habilitaFechar = false
      }

      for (i = 0; i < res.data.length; i++) {
        res.data[i].idPedido = idPedido;
        self.arquivosCertidao.push(res.data[i])
      }
    },
    respConfirm(resp) {
      if (resp == "s") {
        const token = localStorage.getItem('jwtToken')
        //console.log(token);
        //const cartorios = this.items;
        //const filtro = cartorios.filter(d => d.idPedido === this.bolSel)
        //fitro = filtro.filtro[0];
        //console.log(cartorios);
        const dadosParaEnvio = { filtro: this.boletoSelecionado, formaPagamento: this.formaPagamento };
        //teste
        //console.log(dadosParaEnvio);
        this.$refs['modalLoading'].show();

        API.post(`certidao/gerarBoleto`, { token: token, dados: dadosParaEnvio }).then((res) => {
          //console.log(res);
          if (res.data.situacao == 1) {
            this.get_certidoes();

            if (this.formaPagamento.toString().includes("credit") == true) {
              API.post(`certidao/exibeBoleto/` + res.data.idBoleto, { token: token }).then((resPdf) => {
                //console.log(resPdf);
                this.pdf = resPdf.data.urlBoleto;
                this.$refs['modalLoading'].hide();
                this.$refs['modalBoleto'].show();

                //console.log(resPdf.data.urlBoleto);
              }).catch(() => {
                console.log("Boleto não encontrado");
              });
            }
            else if (this.formaPagamento == 2) {
              // console.log('download_boleto_' + this.boletoSelecionado.cd_pedido)
              this.$refs['modalLoading'].hide();
              let dwnldAnexo = document.getElementById('download_boleto');
              dwnldAnexo.href = res.data.urlBoleto;
              //setTimeout(function(){
              dwnldAnexo.click();
              this.$refs['modalPagamento'].hide();
            }
            else if (this.formaPagamento == 3) {
              // console.log('download_boleto_' + this.boletoSelecionado.cd_pedido)
              this.linkPIX = res.data.urlBoleto;
              var Quickchart = 'https://quickchart.io/qr?size=300&text=';
              this.pdf = Quickchart + encodeURI(this.linkPIX);
              // GoogleCharts QR Code - DEPRECATED
              // var GoogleCharts = 'https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=';
              // this.pdf = GoogleCharts + this.linkPIX;

              this.sizemodalboleto = 'lg'
              this.startCountDown(30);
              let self = this
              let countInterval2 = setInterval(() => {
                self.startCountDown(30);
                self.verificaPagamento(res.data.idBoleto)
              }, 30000)
              this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                if (modalId == 'modalboleto' && bvEvent.type == 'hidden') clearInterval(countInterval2)
              })

              this.$refs['modalLoading'].hide();
              this.$refs['modalPagamento'].hide();
              this.$refs['modalBoleto'].show();
            }
          }
          else {
            this.mensagemBolErro = res.data.mensagem;
            this.$refs['modalLoading'].hide();
            this.$refs['modalBoleto'].show();
          }
          //let resJson = JSON.parse(res.data['enviada']);
          //console.log(resJson);
        }).catch(erro => {
          console.log("post não enviado", erro);
        })
      }
      if (resp == "n") this.$refs['modalPagamento'].hide();

    },
    gerarBoleto(dadosTitulo) {
      //console.log(dadosTitulo);
      this.linkPIX = '';
      this.formaPagamento = 0;
      this.$refs['modalPagamento'].show();
      // this.$bvModal.show('modal-conf');
      this.boletoSelecionado = dadosTitulo;
      this.simulacaoPagamentos(dadosTitulo.vl_orcServ)
      //localStorage.setItem('idPedido');
      //this.bolSel = pedidoid;
    },
    async simulacaoPagamentos(vlr_simulacao) {
      let valor_simulado = parseFloat(vlr_simulacao).toFixed(2).replace('.', '') / 1
      let resSimulacao = await axios.get(`${process.env.VUE_APP_URL_EXPRESS}/v1/simulation/sellers/${process.env.VUE_APP_SELLER_KEY_EXPRESS}?amount_cents=${valor_simulado}`);
      // console.log(resSimulacao.data)
      // resSimulacao = JSON.parse(resSimulacao.data);
      // console.log(resSimulacao.installment_amount_cents)
      let formasPagamentoSimulacao = resSimulacao.data.filter(d => d.type == 'credit')
      let self = this
      this.formasPagamentoExpress = formasPagamentoSimulacao
      formasPagamentoSimulacao.forEach((value) => {
        self.formasPagamento.push({ html: '<b> Cartão de Crédito - Parcela Express  ' + value.installment + ' x ' + this.formataReais(value.installment_amount_cents) + '</b> ( Tarifa Bancária - ' + value.cet + '% )', 'value': value.code })
      })
    },
    formataReais(number) {
      number = parseFloat((number / 100)).toFixed(2);
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(number);
    },
    apenasNumeros(string) {
      var numsStr = string.replace(/[^0-9]/g, '');
      return parseInt(numsStr);
    },
    selecionarBoleto(dadosTitulo) {
      this.linkPIX = '';
      this.formaPagamento = 0;
      this.boletoSelecionado = dadosTitulo;
      let cd_certidao = this.boletoSelecionado.cd_certidao
      const token = localStorage.getItem('jwtToken')
      API.post(`certidao/idBoleto/` + cd_certidao, { token: token }).then((res) => {
        //console.log(res.data.cd_boleto)
        this.visualizarBoleto(res.data.cd_boleto, res.data.sg_prefixo_identificador)
      });
      //
    },
    cancelar_pedido(row) {
      this.cd_pedido_atual = row.cd_pedido
      this.motivo_cancelamento = null
      this.mensagem = "Está ação é irreversível. <br><br> Deseja cancelar o Pedido: <b>" + this.cd_pedido_atual + "</b>"
      this.$refs['cancelar_pedido'].show();

    },
    fechar_modal() {
      this.$refs['cancelar_pedido'].hide();
    },
    efetua_cancelamento_pedido() {
      this.carregando = true
      const token = localStorage.getItem('jwtToken')
      let self = this
      API.post(`certidao/cancelar_pedido`, { token: token, cd_pedido: this.cd_pedido_atual, motivo: this.motivo_cancelamento }).then(() => {
        self.cd_pedido_atual = null
        self.motivo_cancelamento = null
        self.mensagem = null
        self.carregando = false
        self.$refs['cancelar_pedido'].hide();
        self.buscar()

      });

    },
    startCountDown(duration) {

      let secondsRemaining = duration;
      let sec = 0;
      let self = this

      let countInterval = setInterval(function () {

        sec = parseInt(secondsRemaining % 60);

        self.secondcd = sec;

        secondsRemaining = secondsRemaining - 1;
        if (secondsRemaining < 0) clearInterval(countInterval);

      }, 1000);
    },
    visualizarBoleto(cd_boleto, sg_prefixo_identificador) {
      let self = this
      this.$refs['modalLoading'].show();
      const token = localStorage.getItem('jwtToken')
      API.post(`certidao/exibeBoleto/` + cd_boleto, { token: token }).then((resPdf) => {
        //console.log(resPdf);
        this.$refs['modalLoading'].hide();
        this.pdf = resPdf.data.urlBoleto;
        this.$refs['modalBoleto'].show();

        if (sg_prefixo_identificador == 'EPP') {
          this.linkPIX = resPdf.data.urlBoleto;
          // GoogleCharts QR Code - DEPRECATED
          // var GoogleCharts = 'https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=';
          // this.pdf = GoogleCharts + resPdf.data.urlBoleto;
          var Quickchart = 'https://quickchart.io/qr?size=300&text=';
          this.pdf = Quickchart + encodeURI(this.linkPIX);
          self.sizemodalboleto = 'lg'
          this.verificaPagamento(cd_boleto)
          self.startCountDown(30);
          let countInterval2 = setInterval(() => {
            self.startCountDown(30);
            self.verificaPagamento(cd_boleto)
          }, 30000)
          this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if (modalId == 'modalboleto' && bvEvent.type == 'hidden') clearInterval(countInterval2)
          })
        }

        if (sg_prefixo_identificador == 'EPB') {
          setTimeout(function () {
            self.$refs['modalBoleto'].hide()
          }, 3000);
        }

        //console.log(resPdf.data.urlBoleto);
      }).catch((e) => {
        console.log("Boleto não encontrado" + e);
      });
      //console.log(cd_cartorio);
    },
    onRowClicked(item, index) {
      item._showDetails = !item._showDetails;
      this.gravaIndexPedido(index);
    },
    async verificaPagamento(cd_boleto) {
      const token = localStorage.getItem('jwtToken')
      const res = await API.post('certidao/consultapagamento', { token: token, cd_boleto: cd_boleto })
      if (res.data.status == 'succeeded') {
        this.get_certidoes();
        this.$refs['modalBoleto'].hide()
      }
    },
    filtrarBusca(filtros) {
      // TODO - certidao/usuario não possui consulta por:
      //            - Nr Pedido (Cancelamento/Certidao)
      //            - Nr Titulo (Cancelamento)
      //            - Vl Titulo (Cancelamento)
      //            - Vl Protestado (Cancelamento)
      this.form = {
        DataInicial: (filtros.dt_cadastro !== null && filtros.dt_cadastro !== undefined ? filtros.dt_cadastro : ''),
        DataFinal: (filtros.dtVencimento !== null && filtros.dtVencimento !== undefined ? filtros.dtVencimento : ''),
        DataSolicitacao: ((filtros.dt_cadastro !== null && filtros.dt_cadastro !== undefined)
          && (filtros.dtVencimento === null && filtros.dtVencimento === undefined && filtros.dtVencimento !== '') ? filtros.dt_cadastro : ''),
        nomePesquisado: (filtros.nm_devedor !== null && filtros.nm_devedor !== undefined ? filtros.nm_devedor : ''),
        documentoPesquisado: (filtros.nm_nr_identificacao_devedor !== null && filtros.nm_nr_identificacao_devedor !== undefined ? filtros.nm_nr_identificacao_devedor : ''),
        status: (filtros.status !== null && filtros.status !== undefined ? filtros.status : ''),
        nrPedido: (filtros.nrPedido !== null && filtros.nrPedido !== undefined ? filtros.nrPedido : ''),
        vl_titulo: (filtros.vl_titulo !== null && filtros.vl_titulo !== undefined ? filtros.vl_titulo : ''),
        vl_saldo: (filtros.vl_saldo !== null && filtros.vl_saldo !== undefined ? filtros.vl_saldo : ''),
      };
      this.get_certidoes();
    },
    async get_certidoes() {
      this.items = []
      this.loading = true;
      const token = localStorage.getItem('jwtToken')
      /*API.get(`certidao/consultaStatusBoleto?token=${token}`).then((resta) => {
        console.log(resta.data);
      });*/
      const res = await API.get(`certidao/usuario?token=${token}&dini=${this.form.DataInicial}&dfim=${this.form.DataFinal}&dtSoli=${this.form.DataSolicitacao}&nmpesq=${this.form.nomePesquisado}&docp=${this.form.documentoPesquisado}&st=${this.form.status}&tpPedido=${this.cd_produto}&nrPedido=${this.form.nrPedido}&vl_titulo=${this.form.vl_titulo}&vl_saldo=${this.form.vl_saldo}&primeiraBusca=${this.primeiraBusca}`)
      this.primeiraBusca = false;
      this.items = res.data
      this.loading = false;
    },
    checkCep(event) {
      let len = event.target.value.length
      if (len === 8) this.calcular_frete()
    },
    async calcular_frete() {
      this.showLoad = true;
      try {
        const token = localStorage.getItem('jwtToken')
        const res = await API.get(`service/frete/${this.service.cep}?token=${token}`)
        this.service.valor = res.data.Valor[0]
        this.service.prazo = res.data.Prazo[0]

        axios.get(`https://viacep.com.br/ws/${this.service.cep}/json/`).then(resp => {
          if (resp.data.erro == true) {
            this.message = "Cep não encontrado."
          } else {
            console.log(resp.data)
          }
        }).catch(() => {
          this.data = null
        })
      } catch (error) {
        console.error(error)
      } finally {
        this.nameLoad = true
        this.showLoad = false
      }
    },
    async solicitantes() {
      const token = localStorage.getItem('jwtToken')
      const res = await API.get(`usuario/solicitante/${this.solicitante.id}?token=${token}`)
      //console.log(res.data.Valor)
      this.solicitante = res.data.valor
    },
    async consultaPagamento(idPedido) {
      this.$refs['modalLoading'].show();
      const token = localStorage.getItem('jwtToken')
      const resCons = await API.get(`certidao/consultaStatusBoleto/${idPedido}?token=${token}`)
      //console.log(resCons);
      if (resCons.data.status) {
        this.get_certidoes();
        this.$refs['modalLoading'].hide();
      }
      else {
        this.$refs['modalLoading'].hide();
        this.$refs['statusBoleto'].show();
      }
    },
    gravaIndexPedido(indexPedido) {
      //console.log(indexPedido);
      localStorage.setItem('indexPedido', indexPedido)
    },
    documentoInput: function (event) {
      var value = event.target.value
      if (value == null) {
        return '';
      } else {
        let v = value;
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g, "");
        if (v.length < 14) { //CPF
          //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um hífen entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else { //CNPJ
          //Coloca ponto entre o segundo e o terceiro dígitos
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          //Coloca ponto entre o quinto e o sexto dígitos
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          //Coloca uma barra entre o oitavo e o nono dígitos
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          //Coloca um hífen depois do bloco de quatro dígitos
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
        }
        event.target.value = v;
      }
    },
    buscar() {
      if (!this.ip_cancelamento) this.get_certidoes();
      else this.get_ip_cancelamento();
    },
    get_ip_cancelamento: function () {
      const token = localStorage.getItem('jwtToken')
      var self = this
      this.loading = true;
      API.post('/titulos/downloadIPCancelamento', { chave_ip_cancelamento: this.form.chave_ip_cancelamento, token: token },
        {
          // responseType: 'arraybuffer'
        }).then(function (res) {
          if (res.data.result == 1) {

            self.baixarIPCancelamento(res.data.instrumentoProtesto);
          }
          else alert("Erro ao recuperar PDF")
          self.loading = false;
        }, function (err) {
          this.loading = false;
          alert("Erro ao recuperar PDF")
          console.log(err);
        });
    },
    downloadRecibo: function (row) {
      let cd_pedido_cartorio = row.cd_pedido
      const token = localStorage.getItem('jwtToken')
      var self = this
      this.loading = true;
      API.post('/certidao/gerarRecibo', { cd_pedido_cartorio: cd_pedido_cartorio, token: token },
        {
          // responseType: 'arraybuffer'
        }).then(function (res) {
          if (res.data.situacao) {

            // let dwnldAnexo = document.getElementById('Recibo');
            // dwnldAnexo.href = "data:application/pdf;base64," + res.data.pdf;
            // //setTimeout(function(){
            // dwnldAnexo.click();

            const base64String = res.data.pdf; // your base64 string here
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'download_recibo_' + cd_pedido_cartorio + '.pdf'; // the name of the file to download
            link.click();

            if (res.data.pdf_complemento != "") {
              // let dwnldAnexo = document.getElementById('Recibo_complemento');
              // dwnldAnexo.href = "data:application/pdf;base64," + res.data.pdf_complemento;
              // //setTimeout(function(){
              // dwnldAnexo.click();

              const base64String = res.data.pdf_complemento; // your base64 string here
              const byteCharacters = atob(base64String);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = 'download_complemento_recibo_' + cd_pedido_cartorio + '.pdf'; // the name of the file to download
              link.click();
            }
          }
          else alert("Erro ao gerar recibo")
          self.loading = false;
        }, function (err) {
          this.loading = false;
          alert("Erro ao gerar recibo")
          console.log(err);
        });
    },
    downloadCertidaoCancelamento: function (row) {
      let cd_pedido_cartorio = row.cd_pedido
      const token = localStorage.getItem('jwtToken')
      var self = this
      this.loading = true;
      API.post('/certidao/donwloadCertidaoCancelamento', { cd_pedido: cd_pedido_cartorio, token: token },
        {
          // responseType: 'arraybuffer'
        }).then(function (res) {
          if (res.data.situacao) {

            // let dwnldAnexo = document.getElementById('Certidao_Cancelamento');
            // dwnldAnexo.href = "data:application/pdf;base64," + res.data.pdf;
            // //setTimeout(function(){
            // dwnldAnexo.click();

            const base64String = res.data.pdf; // your base64 string here
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'Certidao_Cancelamento' + cd_pedido_cartorio + '.pdf'; // the name of the file to download
            link.click();
          }
          else alert("Erro ao gerar recibo")
          self.loading = false;
        }, function (err) {
          this.loading = false;
          alert("Erro ao gerar recibo")
          console.log(err);
        });
    },
    async verificarConta() {
      const token = localStorage.getItem('jwtToken'),
        res = await API.post('/usuario/termoaceite/mensagemusuario', { token: token, origem: 2 })

      if (res.data.sucesso == 2) {
        // this.$router.push({name: 'cadastroUser', params: {dadosLiq: 'liquidacao', dadosBancarios:0}});
        this.$router.push({ name: 'cadastroUser' });
      }
    },
    async atualizaPagamento(salle_id) {
      const token = localStorage.getItem('jwtToken'), res = await API.post('certidao/atualizaPagamentocc', { token: token, cd_pedido: this.boletoSelecionado.cd_pedido, vl_tarifa: this.percent_value, salle_id: salle_id })
      if (res.data.situacao == true) {
        this.$refs['modalLoading'].hide();
        this.$refs['modalPagamento'].hide();
        this.percent_value = null
        this.get_certidoes();
      }

    },
    calcula_valor_pagamento() {
      this.percent_value = this.get_percent_val(this.boletoSelecionado.vl_orcServ, 2.89)
      let valor_pagamento = parseFloat(this.boletoSelecionado.vl_orcServ) + this.percent_value;
      return valor_pagamento.toFixed(2);

    },
    get_percent_val(val, percent) {
      let percent_val = (parseFloat(val) * parseFloat(percent)) / 100;
      return parseFloat(percent_val.toFixed(2));

    },
    copiarLink() {
      var copyTextarea = this.$refs.copiar

      copyTextarea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'Texto copiado!' : 'Texto não copiado !';
        alert(msg);
      } catch (err) {
        alert('Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.');
      }

    },
    async alteraFPG() {
      this.percent_value = null
      // let valor_calculado = this.calcula_valor_pagamento();
      let self = this
      let retornoIP = await axios.get(`https://api.ipify.org/?format=json`)

      const token = localStorage.getItem('jwtToken')
      let costumerBillinAdrres = await API.get(`usuario/logado/endereco?token=${token}`)
      costumerBillinAdrres = costumerBillinAdrres.data

      let description = 'Pagamento Pedido de ' + (self.boletoSelecionado.cd_produto == 3 ? 'Cancelamento Protesto' : 'Certidao ') + 'N: ' + self.boletoSelecionado.cd_pedido;

      setTimeout(function () {
        const web_component = document.querySelector('parcela-checkout');
        let dadosFormaPagamento = self.formasPagamentoExpress.filter(d => d.code == self.formaPagamento)[0]
        let amount_cents = dadosFormaPagamento != undefined ? parseInt(dadosFormaPagamento.total_amount_cents) : '';

        if (self.formaPagamento.toString().includes("credit") == true) {
          web_component.customerData = {
            amount_cents: amount_cents,
            description: description,
            form_payment: "credit",
            installment_plan: {
              number_installments: dadosFormaPagamento.installment,
            },
            customer: {
              email: localStorage.getItem('usrEmail'),
              ip: retornoIP.data.ip,
              first_name: localStorage.getItem('usrName'),
              last_name: " ",
              document: localStorage.getItem('usrCpf'),
              billing_address: {
                city: costumerBillinAdrres.cidade || 'São Paulo',
                country: costumerBillinAdrres.pais || 'Brasil',
                house_number_or_name: costumerBillinAdrres.numero || '377',
                postal_code: costumerBillinAdrres.cep ? costumerBillinAdrres.cep.replace('-', '') : '01009906',
                state: costumerBillinAdrres.estado || 'SP',
                street: costumerBillinAdrres.rua || 'Rua Líbero Badaró',
              },
            },
            extract_identification: 'IEPTB-BR',
            pre_capture: false,
            has_split_rules: false,
            confirmation_required: false,
          };

          web_component.onChange = () => {
            // console.log(state);
          }

          web_component.beforeSubmit = () => self.$refs['modalLoading'].show();

          web_component.onSubmit = (state) => {
            self.$refs['modalLoading'].show();
            if (state.resultCode == 'Authorised') {
              self.atualizaPagamento(state.sale_id);
            }
            else {
              self.$refs['modalLoading'].hide();
              self.$refs['ModalPagamentoCartao'].show();
            }
          };
        }
      }, 1)
    },
    confirmar() {
      this.$router.push(this.errorPush)
      this.$refs['erro'].hide();
    },
  },
}
</script>

<style scoped>
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}

.container-fluid {
  width: 100% !important;
}

#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}

#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 80px);
  background-color: #ffffff;
  overflow-x: hidden;
  border-top: 1px solid #f1f1f1;
}

.lista-certidoes {
  color: #000;
}

.lista-certidoes b {
  font-size: 0.85rem;
  color: var(--main-azul);
}

.textPainel {
  color: #004E86;
  /* font-family: "TimeBurner Bold" !important; */
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #004E86 !important;
  border-color: #004e86 !important;
}

a {
  color: #555;
}

.shadow {
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}

#loading-solicitante {
  vertical-align: 0;
  margin-left: -21px;
}

.load {
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spin {
  background: #fff;
  height: 80px;
  width: 80px;
  border-radius: 50vh;
  border-color: #209CEE;
  border-top: 5px solid #209CEE;
  animation: loading 3s linear infinite;
}

.loading {
  position: absolute;
  color: #000;
}

@keyframes loading {
  100% {
    transform: rotate(360deg)
  }
}

.bold {
  font-weight: bold;
}

.mensagemErro {
  color: red;
}

@media (min-width: 992px) {
  .col-lg-3 {
    max-width: 22% !important;
  }
}

.qrcodePix {
  height: 300px;
}

.espaco-menu {
  width: calc(296px + 5px + 5px);
  flex: unset;
  margin-left: calc(3.8vw - 5px);
}

#painel>.row {
  justify-content: space-between;
}

#painel {
  scrollbar-width: none;
}

#painel::-webkit-scrollbar {
  display: none;
}

#painel h1 {
  text-align: left;
  font: normal normal bold 25px/41px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597EB5;
  margin-bottom: 22px;
}

#painelcontainerfluid {
  padding: 0;
  padding-bottom: 52px;
  padding-right: 3.8vw;
  margin-top: 37px;
}

.cards-painel {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 50px 30px;
  justify-content: center;
  margin: 0 auto;
}

.card-painel {
  border: 3px solid #597EB5;
  border-radius: 20px;
  padding: 20px;
  flex: 1 1 40%;
  max-width: 40%;
  text-decoration: none;
  height: 150px;
}

.card-painel span {
  color: white;
  font: 'Kanit', sans-serif;
  font-size: 24px;
  line-height: 37px;
  font-weight: 500;
  letter-spacing: -1%;
  /* color: var(--navbar-gray-color) !important; */
}

.card-painel:nth-child(1) {
  border-color: #fe7d43;
  background-color: #fe7d43CF;
}

.card-painel:nth-child(2) {
  border-color: #4780f1;
  background-color: rgba(71, 128, 241, .8117647058823529);
}

.card-painel:nth-child(3) {
  border-color: #c3ddf7;
  background-color: rgba(195, 221, 247, .8117647058823529);
}

.card-painel:nth-child(4) {
  border-color: #7884eb;
  background-color: rgba(120, 132, 235, .8117647058823529);
}

.card-painel:nth-child(5) {
  border-color: #1aceb5;
  background-color: rgba(26, 206, 181, 0.8117647058823529);
}

.card-painel:nth-child(6) {
  border-color: #fb7c82;
  background-color: rgba(251, 124, 130, .8117647058823529);
}

@media (max-width:1600px) and (min-width:1400px) {
  .espaco-menu {
    margin-left: calc(20px - 5px) !important;
  }

  #painelcontainerfluid {
    padding-right: 20px !important;
  }
}

@media (max-width:1399px) and (min-width:1200px) {
  .espaco-menu {
    margin-left: calc(10px - 5px) !important;
  }

  #painelcontainerfluid {
    padding-right: 10px !important;
  }
}

@media (max-width:1199px) {
  #painel {
    padding: 0 17px;
  }

  #painel>.row {
    width: 100%;
    /* max-width: none; */
    margin: 0 !important;
    padding: 0px !important;
    margin-bottom: 70px !important;
    /* margin-left: -17px !important; */
    max-width: 100%;
    margin-left: 0px !important;
  }

  .col-lg-9 {
    max-width: none;
    flex: 1 1 100%;
    padding: 0;
  }

  #painelcontainerfluid {
    padding: 0px !important;
  }

  .cards-painel {
    gap: 20px 30px;
  }

  .card-painel {
    flex: 1 1 100%;
    max-width: 100%;
    text-decoration: none;
    height: 150px;
  }

  .card-painel img {
    height: 100px;
    width: 100px !important;
  }
}

.breadcrumb {
  margin-left: 0px;
  background: unset;
}

.breadcrumb a,
.breadcrumb span,
.breadcrumb-item+.breadcrumb-item::before {
  font: normal normal 200 16px/20px 'Kanit', sans-serif;
}

.breadcrumb-item+.breadcrumb-item::before {
  float: unset;
}

.breadcrumb a {
  color: var(--primary-color);
}

.breadcrumb-item+.breadcrumb-item::before {
  color: var(--primary-color);
}

.breadcrumb span {
  color: var(--secondary-color);
}

.breadcrumb a.disabled {
  text-decoration: none;
  cursor: default;
}

.btn-voltar {
  display: flex;
  align-items: center;
  margin-left: auto;
  letter-spacing: 0px;
  text-decoration: none;
  justify-content: flex-end !important;
  margin-bottom: 20px;
}

.btn-voltar img {
  width: 20px;
  height: 20px;
  margin-left: 6px;
}
</style>
